import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CheckmarkComponent } from '../checkmark';
import { ErrorMarkComponent } from '../error-mark';

export interface IConfirmData {
  message: string;
  title: string;
  type?: 'error' | 'success';
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatDialogModule, SmartusComponentsModule, CheckmarkComponent, ErrorMarkComponent],
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IConfirmData) {}
}
